import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderService } from '../core/loader.service';

/**
 * The blocking overlay for mutations, driven by the ref-counted LoaderService.
 *
 * Replaces `<ngx-spinner type="ball-scale-multiple">`. Same trigger exactly:
 * `loading.interceptor.ts` still counts only POST/PUT/PATCH/DELETE and still
 * exempts the same silent mutations, so the overlay appears on precisely the
 * requests it appeared on before.
 *
 * `aria-busy` + `role="status"` so the block is announced rather than being a
 * silent freeze.
 */
@Component({
  selector: 'ui-busy-overlay',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-busy-overlay.component.html',
  host: { '[attr.aria-busy]': 'loader.isLoading()', role: 'status' },
})
export class UiBusyOverlayComponent {
  readonly loader = inject(LoaderService);
  /** Already translated. Empty renders the spinner alone. */
  @Input() label = '';
}
